import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HighchartsChartComponent} from 'highcharts-angular';
import {BrowserModule} from '@angular/platform-browser';
import {WidgetItemComponent} from '@components/pages/widgets/widget-item/widget-item.component';
import {ChartsModule} from '@components/pages/charts/charts.module';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NgSelectModule} from '@ng-select/ng-select';
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule} from '@angular/forms';
import {SharedModule} from '@shared/shared.module';
import {
  WidgetConfigurationModalComponent
} from '@components/pages/widgets/widget-configuration-modal/widget-configuration-modal.component';
import {WidgetsConfigurationModule} from '@components/pages/widgets/widgets-configuration/widgets-configuration.module';


@NgModule({
  declarations: [
    WidgetItemComponent,
    WidgetConfigurationModalComponent,
  ],
  exports: [
    WidgetItemComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    NgbModule,
    HighchartsChartComponent,
    ChartsModule,
    NgSelectModule,
    TranslateModule,
    FormsModule,
    SharedModule,
    WidgetsConfigurationModule
  ]
})
export class WidgetsModule {
}
